<app-card></app-card>
<app-acc-toggle size="small" name="skip_notification" (change)="changed()" [(ngModel)]="accToggleValue"
  style="width: 20%; justify-content: flex-end; display: flex; margin-top: -5rem; margin-bottom: -2rem; margin-left: 80%;">
</app-acc-toggle>


<section id="partattachment" class="clearfix">
  <app-part-attachment></app-part-attachment>
</section>


<app-acc-toggle size="small" name="skip_notification" (change)="changed()" [(ngModel)]="accToggleValue"
  style="width: 20%; justify-content: flex-end; display: flex; margin-top: -5rem; margin-bottom: -2rem; margin-left: 80%;">
</app-acc-toggle>
<section id="attachfiles" class="clearfix" style="margin-left: 3rem; margin-right: 3rem;">
  <app-attach-file></app-attach-file>
</section>
<app-file-catalyst-modal ng-init="expression" modalId="fromageId" modalTitleId="fromageTitle">
  <div modal-title>

  </div>
  <div modal-close>
    <button style="display:none" class="dds__close" id="closeModal" data-dismiss="dds__modal" aria-label="Close">
      <span class="dds__icons dds__close-x" aria-hidden="true"></span>
    </button>
  </div>
  <div modal-body>
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1">
        <p><strong>Note: For Dell internal users, please download the agent from the company portal.</strong></p>
        Unable to detect the Accelerating Agent - File Catalyst. Please click the <a href="javascript:void(0)"
          (click)="downloadFile()">download link</a>
        to download and install, the pop-up closes automatically after starting the agent. If the agent is already
        installed, click <a id="openAgent" href="filecatalyst:">start-agent</a> to open the Agent, it takes about 2
        minutes for the Agent to get started. Or click 'Continue' to continue without acceleration.
        For more information, download the FileCatalyst-Transfer_Agent.docx from User Guides section. Please upgrade to
        recent version:3.9, after uninstalling the old version.
      </h3>
    </div>

  </div>
  <div modal-footer>
    <div style="position: relative;">
      <button type="button" data-dismiss="dds__modal" aria-label="Close" class="dds__close"
        class="dds__btn dds__btn-secondary dds__text-truncate" (click)="continueWA()">Skip Acceleration
      </button>
    </div>
  </div>
  <span modal-trigger id="downloadUtility">

  </span>
</app-file-catalyst-modal>
